import { Text, TextProps } from "../../";
import { EmotionComponent } from "../../styled";
import { OverrideNativeElementProps } from "../../utils/styleFn";

export type HeadingProps = EmotionComponent<
  OverrideNativeElementProps<TextProps, "h1">
>;

export type HeadingTypes = {
  h1: HeadingProps;
  h2: HeadingProps;
  h3: HeadingProps;
  h4: HeadingProps;
  h5: HeadingProps;
  h6: HeadingProps;
};

export const Heading: HeadingTypes = {
  h1: Text.withComponent("h1"),
  h2: Text.withComponent("h2"),
  h3: Text.withComponent("h3"),
  h4: Text.withComponent("h4"),
  h5: Text.withComponent("h5"),
  h6: Text.withComponent("h6"),
};

Heading.h1.defaultProps = {
  textStyle: "h1",
};
Heading.h1.displayName = "Heading.h1";

Heading.h2.defaultProps = {
  textStyle: "h2",
};
Heading.h2.displayName = "Heading.h2";

Heading.h3.defaultProps = {
  textStyle: "h3",
};
Heading.h3.displayName = "Heading.h3";

Heading.h4.defaultProps = {
  textStyle: "h4",
};
Heading.h4.displayName = "Heading.h4";

Heading.h5.defaultProps = {
  textStyle: "h5",
};
Heading.h5.displayName = "Heading.h5";

Heading.h6.defaultProps = {
  textStyle: "h6",
};
Heading.h6.displayName = "Heading.h6";

export const HeadingPropTable: HeadingProps = Heading.h1;
HeadingPropTable.displayName = "Heading.h1";

export default Heading;
